"use strict";
import React from "react";
import { Link } from "react-router-dom";
import FormsyFields from "./formsyFields";
import Formsy from "./formsy";
import loaders from "./loaders";
import FormsyInputInteractive from './prism/FormsyElements/FormsyInputInteractive';
import {
    getPasswordValidation,
    notEqualsIgnoreCase
} from '../util/validationUtils';
import {
    redirectToDefaultPage
} from '../util/helpers';
import classNames from 'classnames';
import PrismRow from "./prism/utilities/prismRow";
import PrismMessage from "./prism/message/prismMessage";
import PrismButton from "./prism/button/prismButton";
const { LaddaButton } = flex.lib;

const initComponent = (flex = window.flex) => {
    
    class UpdateSecuritySettings extends React.PureComponent {
        state = {
            expiredToken: true,
            canSubmit: false,
            alertMsg: "",
            securityQuestion1: "-1",
            securityQuestion2: "-1",
            answer1: "",
            answer2: "",
            password: "",
            confirmPassword: "",
            tryCounter: 0,
            isSystemMessage: false
        };

        componentDidMount() {
            const { userId, updateSecuritySettingsToken } = this.props;

            if (updateSecuritySettingsToken && userId) {
                this.validateToken(updateSecuritySettingsToken, userId);
            } else {
                redirectToDefaultPage();
            }
        }

        enableButton = () => {
            this.setState({
                canSubmit: true
            });
        };

        disableButton = () => {
            this.setState({
                canSubmit: false
            });
        };

        validateToken = (updateSecuritySettingsToken, userId, onSuccess) => {
            this.setState({ dataReady: false, canSubmit: false });

            flex.setBusy("app:validateToken", true);

            FlexApiRequest.POST({ path: "/api/v1/auth/validatetoken" })
                .send({ passwordResetToken: updateSecuritySettingsToken, userId: userId })
                .then(({ data }) => {
                    if (!this.unmounting) {
                        flex.setBusy("app:validateToken", false);
                        if (!this.unmounting) {
                            this.setState({
                                accountSettings: data,
                                canSubmit: true,
                                dataReady: true
                            });
                            if (typeof onSuccess === "function") {
                                onSuccess();
                            }
                        }
                    }
                })
                .catch(({ handledErrors }) => {
                    const errorMsg = _.map(handledErrors, (e) => { return e.summary; }).join(', ');

                    if (errorMsg) {
                        flex.addPageAlerts({
                            className: 'alert-success',
                            summary: errorMsg,
                            selfCloseTimeout: 15000
                        });
                    }

                    const isTokenExpired = handledErrors.some(error => {
                        return error.code === "10000";
                    });

                    if (isTokenExpired) {
                        setTimeout(function () {
                            redirectToDefaultPage();
                        }, 5000);
                    }
                })
                .finally(() => {
                    flex.setBusy("app:validateToken", false);
                });
        };

        onSecurityQuestionBlur = (questionLabel) => {
            const value = this.state[questionLabel];

            if (value === "-1") {
                this.setState({
                    [questionLabel]: ""
                }, () => this.setState({ [questionLabel]: "-1" }));
            }
        };

        onQuestionSelected = (questionLabel, value) => {
            this.setState({
                [questionLabel]: value
            });
        };

        handleSubmit = (model, reset, invalidate) => {
            const { tryCounter } = this.state;
            const { userId, updateSecuritySettingsToken } = this.props;

            flex.setBusy("app:updateSecuritySettings", true);

            const onValidToken = () => {
                this.setState({
                    answer1: model["answer1"],
                    answer2: model["answer2"],
                    password: model["password"],
                    confirmPassword: model["confirmPassword"]
                });

                FlexApiRequest.POST({ path: "/api/v1/auth/resetpassword" })
                    .send(model)
                    .then((data) => {
                        if (!this.unmounting) {
                            flex.setBusy("app:updateSecuritySettings", false);
                            this.setState({
                                alertMsg: "  ",
                                alertClass: "alert-success",
                                dataReady: true,
                                messageTitle: "Security Settings Saved.",
                                messageType: "success",
                                isSystemMessage: true
                            });
                            setTimeout(function () {
                                redirectToDefaultPage();
                            }, 5000);
                        }
                    })
                    .catch(({ handledErrors }) => {
                        if (handledErrors?.length === 0 || handledErrors?.find(x => (x.code === "500" && x.detail !== null))) {
                            const tryAgainErrorMsg = tryCounter === 0 ? "Please try again. " : "";
                            this.setState({
                                alertMsg: tryAgainErrorMsg + flex.text("UX_CONTACT_CLIENT_CARE", "For assistance, please contact Client Care"),
                                canSubmit: true,
                                dataReady: true,
                                messageTitle: "Something Went Wrong",
                                messageType: "danger",
                                tryCounter: tryCounter + 1,
                                isSystemMessage: true
                            }, () => {
                                if (tryCounter >= 1) {
                                    setTimeout(function () {
                                        redirectToDefaultPage();
                                    }, 5000);
                                }
                            });
                        } else {
                            let errorSummary = "";
                            for (var i = 0; i < handledErrors.length; i++) {
                                let minutes = 0;
                                errorSummary = handledErrors[i].summary;

                                // Jank to extract the number of minutes and replace with a humanized version.
                                if (handledErrors[i].code === "GLOBAL_ERROR_REQUIREDFIELDS") {
                                    errorSummary = flex.text("GLOBAL_ERROR_REQUIREDFIELDS", "Required fields missing.");
                                }
                                else if (handledErrors[i].summary?.indexOf("minutes") > -1) {
                                    minutes = handledErrors[i].summary.match(/\d+/g)[0];
                                    var duration = moment.duration({ minutes: minutes });
                                    errorSummary = handledErrors[i].summary.replace("" + minutes + " minutes", duration.humanize());
                                }
                            }
                            this.setState({
                                alertMsg: errorSummary,
                                canSubmit: true,
                                dataReady: true,
                                messageTitle: "",
                                messageType: "danger"
                            });
                        }
                    })
                    .finally(() => {
                        flex.setBusy("app:updateSecuritySettings", false);
                    });
            };

            if (updateSecuritySettingsToken && userId) {
                this.validateToken(updateSecuritySettingsToken, userId, onValidToken);
            }
        };

        tryAgain = () => {
            this.setState({
                alertMsg: "Please confirm and try again.",
                messageType: "info",
                isSystemMessage: false
            });
        };

        renderHeaderLabel = (text, className) => {
            const subTitleClassNames = classNames('sub-title', className);

            return (
                <h5 className={subTitleClassNames}>
                    {text}
                </h5>
            );
        };

        getQuestionsOptions = () => {
            const { accountSettings, securityQuestion1, securityQuestion2 } = this.state;
            const questions = accountSettings ? accountSettings.secretQuestions : [];

            const question1 = [{ label: "Select question #1", value: "-1" }]
                .concat(questions.filter(question => question !== securityQuestion2).map(questions => ({ label: questions, value: questions })));
            const question2 = [{ label: "Select question #2", value: "-1" }]
                .concat(questions.filter(question => question !== securityQuestion1).map(questions => ({ label: questions, value: questions })));

            return { question1, question2 };
        };

        renderErrorMessageSection = () => {
            const { messageTitle, messageType, tryCounter, alertMsg } = this.state;
            
            return (
                <div className="update-security-settings__container col-12">
                    <div className="update-security-settings__page-title">
                        <h1>SECURITY SETTINGS</h1>
                    </div>
                    <PrismRow>
                        <div className="col-md-12">
                            <PrismMessage title={messageTitle} color={messageType}>
                                {alertMsg}
                            </PrismMessage>
                        </div>
                    </PrismRow>
                    {
                        messageType === "danger" && tryCounter < 2
                        && <PrismRow>
                            <div className="update-security-settings__retry-button col-md-12">
                                <PrismButton onClick={this.tryAgain} >
                                    Try Again
                                </PrismButton>
                            </div>
                        </PrismRow>
                    }
                </div>
            );
        };

        renderTryAgainSection = () => {
            const { messageType, alertMsg } = this.state;
            return (
                messageType !== "success" && alertMsg
                && <PrismRow>
                    <div className="col-md-12">
                        <PrismMessage color={messageType}>{ alertMsg }</PrismMessage>
                    </div>
                </PrismRow>
            );
        };

        renderUsernameSection = () => {
            const { accountSettings } = this.state;

            return (
                <PrismRow>
                    <div className="col-md-12">
                        <h2>Username</h2>
                        {this.renderHeaderLabel(accountSettings?.username)}
                    </div>
                </PrismRow>
            );
        };

        renderSecurityQuestionsSection = () => {
            const { securityQuestion1, securityQuestion2, answer1, answer2 } = this.state;
            const { question1, question2 } = this.getQuestionsOptions();
            const formProps = { layout: "vertical" };
            const isSaving = flex.isBusy("app:updateSecuritySettings");

            return (
                <>
                    <PrismRow>
                        <div className="col-md-12">
                            <h2>Security Questions</h2>
                            {this.renderHeaderLabel("(All fields are required)", "dark")}
                        </div>
                    </PrismRow>
                    
                    <PrismRow>
                        <div className="col-sm-6">
                            <FormsyFields.Select
                                {...formProps}
                                id="securityQuestion1"
                                name="securityQuestion1"
                                className="security-question-select form-control"
                                value={securityQuestion1}
                                options={question1}
                                onChange={this.onQuestionSelected}
                                onBlur={() => this.onSecurityQuestionBlur('securityQuestion1')}
                                validations={{
                                    myCustomValidation: (values, value) => value !== "-1"
                                }}
                                validationError="Security question is required."
                                required={true}>
                            </FormsyFields.Select>
                        </div>
                        <div className="col-sm-6">
                            <FormsyInputInteractive
                                {...formProps}
                                id="answer1"
                                name="answer1"
                                autoComplete="off"
                                value={answer1}
                                placeholder="Type your answer"
                                required={true}
                                validations="minLength:1"
                                validationError="Answer for security question is required."
                                type="text"
                                disabled={isSaving}
                            />
                        </div>
                    </PrismRow>
                    <PrismRow>
                        <div className="col-sm-6">
                            <FormsyFields.Select
                                {...formProps}
                                id="securityQuestion2"
                                name="securityQuestion2"
                                className="security-question-select form-control"
                                options={question2}
                                onBlur={() => this.onSecurityQuestionBlur('securityQuestion2')}
                                value={securityQuestion2}
                                onChange={this.onQuestionSelected}
                                validations={{
                                    myCustomValidation: (values, value) => value !== "-1"
                                }}
                                validationError="Security question is required."
                                required={true}>
                            </FormsyFields.Select>
                        </div>
                        <div className="col-sm-6">
                            <FormsyInputInteractive
                                {...formProps}
                                id="answer2"
                                name="answer2"
                                autoComplete="off"
                                value={answer2}
                                placeholder="Type your answer"
                                required={true}
                                validations="minLength:1"
                                validationError="Answer for security question is required."
                                type="text"
                                disabled={isSaving}
                            />
                        </div>
                    </PrismRow>
                </>
            );
        };

        renderNewPasswordSection = () => {
            const { accountSettings, password, confirmPassword } = this.state;
            
            const passwordValidation = getPasswordValidation();
            const isSaving = flex.isBusy("app:updateSecuritySettings");

            return (
                <>
                    <PrismRow>
                        <div className="col-md-12">
                            <h2>New Password</h2>
                            {this.renderHeaderLabel("(All fields are required)", "dark")}
                        </div>
                    </PrismRow>
                    <ul className="col-md-12 password-rule">
                        <li>Must be at least 8 characters</li>
                        <li>Cannot be your Username</li>
                        <li>Must include UPPER and lower case, at least 1 number and 1 special character</li>
                    </ul>
                    <PrismRow>
                        <div className="col-sm-6" className={classNames("col-sm-6", {"disabled-password": isSaving})}>
                            <FormsyInputInteractive
                                iconLeft="prism-icon-locked icon"
                                id="password"
                                name="password"
                                placeholder="Type a new password"
                                type="password"
                                required={true}
                                validationError="Password is required."
                                value={password}
                                validations={{
                                    ...passwordValidation.validators,
                                    notEqualsToUserName: model => notEqualsIgnoreCase(model['password'], accountSettings && accountSettings.username)
                                }}
                                validationErrors={{
                                    ...passwordValidation.errorMessages,
                                    notEqualsToUserName: 'Password cannot be the same as Username'
                                }}
                                disabled={isSaving}
                            />
                            <FormsyInputInteractive
                                iconLeft="prism-icon-locked icon"
                                id="confirmPassword"
                                name="confirmPassword"
                                placeholder="Re-enter new password"
                                type="password"
                                value={confirmPassword}
                                required={true}
                                validations="equalsField:password"
                                validationError="Passwords do not match"
                                disabled={isSaving}
                            />
                        </div>
                    </PrismRow>
                </>
            );
        };

        renderActionSection = () => {
            const { canSubmit } = this.state;
            const isSaving = flex.isBusy("app:updateSecuritySettings");

            return (
                <div className="form-group">
                    <div className="row">
                        <div className="col-xs-6 col-sm-5 col-sm-offset-4 col-md-4 col-md-offset-4 text-right">
                            <Link disabled={isSaving} className="btn btn-cancel" onClick={() => redirectToDefaultPage()}>
                                {flex.text("UX_ACT_CANCEL")}
                                </Link>
                        </div>
                        <div className="col-xs-6 col-sm-3 col-md-4">
                            <LaddaButton
                                type="submit"
                                loading={isSaving}
                                className="btn"
                                disabled={!canSubmit}
                            >
                                Save
                            </LaddaButton>
                        </div>
                    </div>
                </div>
            );
        };

        render() {
            const { userId, updateSecuritySettingsToken } = this.props;
            const { accountSettings, alertMsg, isSystemMessage } = this.state;

            const isSaving = flex.isBusy("app:updateSecuritySettings");
            const formProps = { layout: "vertical" };
            const accountResults = 
                isSystemMessage && alertMsg && alertMsg !== ''
                ? this.renderErrorMessageSection()
                : <>
                    {this.renderTryAgainSection()}
                    {this.renderUsernameSection()}
                    {this.renderSecurityQuestionsSection()}
                    {this.renderNewPasswordSection()}
                    {this.renderActionSection()}
                    <FormsyFields.Input {...formProps} id="userId" name="userId" value={userId} type="hidden" autoComplete="off" />
                    <FormsyFields.Input {...formProps} id="passwordResetToken" name="passwordResetToken" value={updateSecuritySettingsToken} type="hidden" autoComplete="off" />
                </>
                
            return (
                <div className="container update-security-settings">
                    <section className="page-sub">
                        { 
                            !isSystemMessage && <div className="update-security-settings__page-title">
                                <h1>SECURITY SETTINGS</h1>
                            </div>
                        }
                        <Formsy.Form className="update-security-settings__form" onValidSubmit={this.handleSubmit} onValid={this.enableButton} onInvalid={this.disableButton} disabled={isSaving}>
                            <fieldset>
                                {accountSettings ? accountResults : false}
                            </fieldset>
                        </Formsy.Form>
                    </section>
                </div>
            );
        }
    }

    return UpdateSecuritySettings;
};

module.exports = initComponent;
